const constants = {
  WEEKS_LOCAL: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  WEEKS_COUNT: 7,
  TABLE_LINE: 6,
  MONTHS_LOCAL: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  YEARS_PERIOD: 20
};

export default constants;



// WEBPACK FOOTER //
// ./js/components/calendar/constants.js